import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-sticky-large.tsx
/**
* icon.24.sticky.large
*
* Keywords: note, paper, document, page, curl, corner, sheet, memo
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTE4IDRhMiAyIDAgMCAxIDIgMnY2LjE3MmwtLjAxLjE5N2EyIDIgMCAwIDEtLjU3NiAxLjIxN2wtNS44MjggNS44MjgtLjE0Ni4xMzNhMiAyIDAgMCAxLTEuMjY4LjQ1M0g2bC0uMjA0LS4wMUEyIDIgMCAwIDEgNCAxOFY2YTIgMiAwIDAgMSAyLTJ6TTYgNWExIDEgMCAwIDAtMSAxdjEyYTEgMSAwIDAgMCAxIDFoNnYtNWEyIDIgMCAwIDEgMi0yaDVWNmExIDEgMCAwIDAtMS0xem04IDhhMSAxIDAgMCAwLTEgMXY0LjU4NkwxOC41ODYgMTN6Ii8+PC9zdmc+)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-3174
*/
const Icon24StickyLarge = memo(function Icon24StickyLarge(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24L",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M18 4a2 2 0 0 1 2 2v6.172l-.01.197a2 2 0 0 1-.576 1.217l-5.828 5.828-.146.133a2 2 0 0 1-1.268.453H6l-.204-.01A2 2 0 0 1 4 18V6a2 2 0 0 1 2-2zM6 5a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h6v-5a2 2 0 0 1 2-2h5V6a1 1 0 0 0-1-1zm8 8a1 1 0 0 0-1 1v4.586L18.586 13z"
		})
	});
});
//#endregion
export { Icon24StickyLarge };

//# sourceMappingURL=icon-24-sticky-large.js.map